<tlk-listbox
	*ngIf="treatmentListItems.length"
	class="rx-intuitive-teeth-treatment-viewlist__listbox"
	[size]="'l'"
	[multiple]="false"
	[hideSelectionIndicator]="true"
	[formControl]="selectedListOptionControl"
>
	<ng-container *ngFor="let item of treatmentListItems; trackBy: trackByKey" ngProjectAs="tlk-listbox-option">
		<tlk-card
			(click)="onItemClick(item)"
			[padding]="cardPadding"
			class="rx-intuitive-teeth-treatment-viewlist__card"
			[class.rx-intuitive-teeth-treatment-viewlist__card--invalid]="item.isInvalid"
		>
			<tlk-listbox-option
				tlkCardContent
				[value]="optionKey(item)"
				class="rx-intuitive-teeth-treatment-viewlist__option"
			>
				<rx-intuitive-tooth-treatment-viewlist-item [item]="item" *ngIf="!isBridge(item)" />
				<rx-intuitive-bridge-treatment-viewlist-item [item]="item" *ngIf="isBridge(item)" />
			</tlk-listbox-option>
		</tlk-card>
	</ng-container>
</tlk-listbox>
